import {
  buildAdjustCoverConfirmationViewEvent,
  buildAdjustCoverInteractionEvent,
  buildAdjustCoverSubmitEvent,
  buildAdjustCoverSubmitResultEvent,
  buildAdjustCoverUnavailableEvent,
  buildDocumentDownloadEvent,
  buildDocumentUploadEvent,
  buildFaqAnswerLinkClickEvent,
  buildFaqInteractionEvent,
  buildRenewalBannerClickEvent,
  buildRenewalBannerImpressionEvent,
  buildRenewalHubEntryEvent,
  buildSelectPromotionEvent,
  buildSetUserPolicyNumbersEvent,
  buildSetUserPropertiesEvent,
  buildTourStartedEvent,
  buildTourStepEvent,
  buildVetConsultSubmittedEvent,
  buildWhatsCoveredEvent
} from './GA4EventBuilder';
import { getDataLayer } from './utils';

export const getGtmService = () => ({
  /**
   * @param {string} contactId
   * @param {string} siteVersion
   */
  pushSetUserProperties: (contactId, siteVersion) => {
    const event = buildSetUserPropertiesEvent(contactId, siteVersion);
    getDataLayer().push(event);
  },
  /**
   * @param {string[]} policyNumbers
   */
  pushSetUserPolicyNumbers: (policyNumbers) => {
    const event = buildSetUserPolicyNumbersEvent(policyNumbers);
    getDataLayer().push(event);
  },
  /**
   * @param {string} documentType
   * @param {string} policyNumber
   */
  pushDocumentDownload: (documentType, policyNumber) => {
    const event = buildDocumentDownloadEvent(documentType, policyNumber);
    getDataLayer().push(event);
  },
  /**
   * @param {string} promotion
   */
  pushSelectPromotion: (promotion) => {
    const event = buildSelectPromotionEvent(promotion);
    getDataLayer().push(event);
  },
  /**
   * @param {string} documentType
   * @param {string} policyNumber
   */
  pushDocumentUpload: (documentType, policyNumber) => {
    const event = buildDocumentUploadEvent(documentType, policyNumber);
    getDataLayer().push(event);
  },
  /**
   * @param {string} policyNumber
   */
  pushWhatsCovered: (policyNumber) => {
    const event = buildWhatsCoveredEvent(policyNumber);
    getDataLayer().push(event);
  },
  /**
   * @param {string} consultType
   */
  pushVetConsultSubmitted: (consultType) => {
    const event = buildVetConsultSubmittedEvent(consultType);
    getDataLayer().push(event);
  },
  /**
   * @param {{ faqQuestion: string, linkText: string, linkUrl: string }} params
   */
  pushFaqAnswerLinkClick: (params) => {
    getDataLayer().push(buildFaqAnswerLinkClickEvent(params));
  },
  pushTourStarted: () => {
    getDataLayer().push(buildTourStartedEvent());
  },
  /**
   * @param {number} stepIndex zero-based index from Joyride's callback
   * @param {string} stepTarget the step's target selector
   */
  pushTourStep: (stepIndex, stepTarget) => {
    getDataLayer().push(buildTourStepEvent(stepIndex, stepTarget));
  },
  pushRenewalBannerImpression: (params) => {
    getDataLayer().push(buildRenewalBannerImpressionEvent(params));
  },
  pushRenewalBannerClick: (params) => {
    getDataLayer().push(buildRenewalBannerClickEvent(params));
  },
  pushRenewalHubEntry: (params) => {
    getDataLayer().push(buildRenewalHubEntryEvent(params));
  },
  pushAdjustCoverUnavailable: (params) => {
    getDataLayer().push(buildAdjustCoverUnavailableEvent(params));
  },
  pushAdjustCoverInteraction: (params) => {
    getDataLayer().push(buildAdjustCoverInteractionEvent(params));
  },
  pushAdjustCoverSubmit: (params) => {
    getDataLayer().push(buildAdjustCoverSubmitEvent(params));
  },
  pushAdjustCoverSubmitResult: (params) => {
    getDataLayer().push(buildAdjustCoverSubmitResultEvent(params));
  },
  pushAdjustCoverConfirmationView: (params) => {
    getDataLayer().push(buildAdjustCoverConfirmationViewEvent(params));
  },
  pushFaqInteraction: (params) => {
    getDataLayer().push(buildFaqInteractionEvent(params));
  }
});
